import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { toastMixin } from './mixins/toast.mixin';
import { userMixin } from './mixins/user.mixin';
import { numberMixin } from './mixins/number.mixin';
import { commonMixin } from './mixins/common.mixin';
import {
  date,
  hour,
  capitalize,
  datetime,
  phone,
  empty,
  formatBoolean,
  price,
  appointment,
  ssn,
  numberWithCommas,
  toBoolean,
} from './filters';
import { datePlugin } from '@/plugins';
import PrimeVue from 'primevue/config';
import Calendar from 'primevue/calendar';
import customDateRange from '@/components/common/CustomDateRange.vue';

import 'bootstrap/dist/js/bootstrap.min.js';

//disable production tip
Vue.config.productionTip = false;

//filters
Vue.filter('date', date);
Vue.filter('hour', hour);
Vue.filter('capitalize', capitalize);
Vue.filter('datetime', datetime);
Vue.filter('phone', phone);
Vue.filter('empty', empty);
Vue.filter('formatBoolean', formatBoolean);
Vue.filter('price', price);
Vue.filter('appointment', appointment);
Vue.filter('ssn', ssn);
Vue.filter('numberWithCommas', numberWithCommas);
Vue.filter('toBoolean', toBoolean);

//core
import './core/vue/error-handler';

//plugins
import './plugins/vee-validate.plugin';
import './plugins/boostrap-vue.plugin';

Vue.use(datePlugin);
Vue.use(PrimeVue, {
  locale: PrimeVueEsCalendarLocales,
});
Vue.component('Calendar', Calendar);
Vue.component('CustomDateRange', customDateRange);

//mixins
Vue.mixin(userMixin);
Vue.mixin(numberMixin);
Vue.mixin(toastMixin);
Vue.mixin(commonMixin);

//styles
import '@/scss/main.scss';
import '@/assets/css/all.css';
import '@/assets/css/solid.css';
import '@/assets/css/style.css';
//Primevue styles
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

//libs
import 'vue-select/dist/vue-select.css';
import 'CustomUserInfoPanel/scss/main.scss';
import PrimeVueEsCalendarLocales from '@/utils/constants/PrimeVueEsCalendarLocales';

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    if (this.isTrainingEnv()) {
      const favicon = document.getElementById('favicon');
      favicon.href = '/favicon-training.ico';
    }
  },
}).$mount('#app');
